// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const StarIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 23.9828L5.72949 28.8L7.5 18.5971L0 11.3714L10.3647 9.88284L15 0.599976L19.6353 9.88284L30 11.3714L22.5 18.5971L24.2705 28.8L15 23.9828Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default StarIcon;
